module.exports = __webpack_public_path__ + "img/0.12789c22.svg";